module.exports = __webpack_public_path__ + "img/order-download.f667d816.svg";